// src/pages/copilot/components/ChatInput.jsx
import { useState } from 'react';
import { Send } from 'lucide-react';

export default function ChatInput({ disabled, onSend, placeholder }) {
  const [text, setText] = useState('');
  const submit = () => {
    if (!text.trim() || disabled) return;
    onSend(text);
    setText('');
  };
  return (
    <div className="chat-input-area">
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder={placeholder || 'Type a message…'}
        rows={3}
        disabled={disabled}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault(); submit();
          }
        }}
      />
      <button className="send-btn" onClick={submit} disabled={disabled || !text.trim()}>
        <Send size={20} />
      </button>
    </div>
  );
}
